import { typo } from '@design-system/styles'
import { css } from '@emotion/react'
import styles from '@mathflat/common/style'

const {
  fontSize,

  colors: { borderColor, gray },
} = styles

const S = css`
  .error-report-header {
    padding: 24px;
    border-bottom: 1px solid ${borderColor};

    > h2 {
      font-size: ${fontSize.heading05};
      font-weight: 700;

      > sub {
        margin-left: 12px;
        color: ${gray.$600};
        font-size: 14px;
        font-weight: 400;
        bottom: 0;
      }
    }
  }

  .error-report-description {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    color: ${gray.$800};
    ${typo.caption01}

    padding: 6px 24px;
    background-color: ${gray.$100};
  }

  .error-report-body {
    margin: 0 24px 24px 24px;
    width: 664px;

    .radio-wrap {
      display: flex;
      align-items: center;
      padding: 14px 0;
      .error-report-radio-group {
        gap: 16px;
        > .radio-label {
          margin: 0;
        }
        .radio-wrap-container {
          position: relative;
        }
        .answer-not-confirmed-tooltip {
          position: absolute;
          top: 36px;
          left: -90px;
          width: max-content;
          display: flex;
          padding: 6px 16px;
          justify-content: center;
          align-items: center;
          gap: 4px;
          border-radius: var(--Radius-200);
          background: var(--Colors-Purple-50);
          color: var(--Colors-Purple-600);
          ${typo.caption01}
          font-weight: 600;
          &.disabled {
            min-width: 438px;
            background: var(--Colors-Gray-200);
            color: var(--Colors-Gray-700);
            &::after {
              border-bottom-color: var(--Colors-Gray-200);
            }
          }
          &::after {
            content: '';
            position: absolute;
            top: -5px;
            left: 100px;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 3.5px solid transparent;
            border-right: 3.5px solid transparent;
            border-bottom: 5px solid var(--Colors-Purple-50);
            border-radius: 1px;
          }
        }
      }
      > p {
        width: 90px;
        color: ${gray.$600};
      }
    }
    textarea {
      padding: 12px;
      width: 100%;
      height: 100px;
      border: 1px solid ${borderColor};
      resize: none;
      letter-spacing: -0.03px;
      line-height: 1.57;
    }
    &.concept {
      width: 534px;
    }
    &.arithmetic textarea {
      height: 134px;
    }
    &.problem {
      .radio-wrap.answer-not-confirmed {
        margin-bottom: 46px;
      }
      &.custom {
        width: 778px;
      }
      .radio-area {
        padding: 14px 0;
        .radio-wrap {
          padding: 0;
          height: 40px;
          & + .radio-wrap {
            margin-top: 4px;
          }
        }
      }
    }
  }
  .error-report-footer {
    display: flex;
    flex-direction: row-reverse;
    margin: 24px;
    margin-top: 0;
  }
`

export default S
